import { TopBrandPromo } from './top_brandpromo';
import { Logger } from './logger';
import { otto } from '@otto-ec/global-resources/nexus';
import { ToAllBrandsLink } from './to_all_brands_link';

if (!otto.ft3.promo.brandpromo.isReady) {
    otto.ft3.promo.brandpromo.assignNamespace({
        init
    }, {
        lock: true
    });
}

function init(): void {
    Logger.group('[FT3 promo brandpromo]');
    Logger.count('TopBrandPromo Invocation');
    const topBrandPromoContainers = document.querySelectorAll('.promo-brandpromo__top-brandpromo');

    topBrandPromoContainers.forEach((container: Element) => {
        if (container.getAttribute('data-tracked') !== 'true') {
            container.setAttribute('data-tracked', 'true');
            new TopBrandPromo(container);
        }
    });

    const toAllBrandsLinkPromoContainers = document.querySelectorAll('.promo-brandpromo__to-all-brands-link');

    toAllBrandsLinkPromoContainers.forEach((container: Element) => {
        if (container.getAttribute('data-tracked') !== 'true') {
            container.setAttribute('data-tracked', 'true');
            new ToAllBrandsLink(container);
        }
    });

    Logger.groupEnd();
}
